import CustomSwiper from '@/_application/core/components/ui/custom-swiper';
import UsefulInformationLoader from '@/_application/core/components/ui/loaders/useful-information-loader';
import {useCategoryPosts, useHomepagePosts} from '@/framework/useful-information';
import rangeMap from '@/lib/range-map';
import {SwiperSlide} from 'swiper/react';
import UsefulInformationItem from './useful-information-item';
import {useEffect} from 'react';
import {Post} from '__generated__/__types__';
import {useRouter} from 'next/router';
import UsefulInformationHeader from '@/_application/modules/useful-information/useful-information-header';

interface IUsefulInformationProps {
    className?: string;
    categoryId?: number;
}

function UsefulInformationMobile({className, categoryId}: Readonly<IUsefulInformationProps>) {
    const {
        fetchData: fetchHomepage,
        isLoading: isHomePageLoading,
        usefulInformation: homepagePosts,
        error: homepageError,
    } = useHomepagePosts();

    const {
        fetchData: fetchCategory,
        isLoading: isCategoryLoading,
        usefulInformation: categoryPosts,
        error: categoryError,
    } = useCategoryPosts();
    const router = useRouter();

    // component is using for homepage or category
    const isHomepage = router.asPath === '/';

    const viewAllLabel = 'Xem thêm các bài viết hay';
    const isLoading = isHomepage ? isHomePageLoading : isCategoryLoading;
    const usefulInformation = isHomepage ? homepagePosts : categoryPosts;
    const error = isHomepage ? homepageError : categoryError;

    const noUsefulInformation = (!isLoading && usefulInformation.length === 0) || error;

    useEffect(() => {
        if (isHomepage) {
            fetchHomepage();
        } else if (categoryId) {
            fetchCategory(categoryId);
        }
    }, []);

    if (!isHomepage && !categoryId) return <></>;
    if (noUsefulInformation) return <></>;

    return (
        <div className={className}>
            <UsefulInformationHeader viewAllLabel={viewAllLabel} />

            <div className={'mx-4'}>
                {isLoading ? (
                    <div className="mt-1 grid grid-cols-4 gap-5">
                        {rangeMap(1, index => (
                            <SwiperSlide key={index} className="cursor-pointer">
                                <div
                                    className={
                                        'mx-auto h-[202px] w-[223px] max-w-md overflow-hidden rounded-[20px] bg-white shadow-md md:h-[214px] md:w-[242px]'
                                    }>
                                    <UsefulInformationLoader key={index} uniqueKey={`product-${index}`} />
                                </div>
                            </SwiperSlide>
                        ))}
                    </div>
                ) : (
                    <CustomSwiper
                        className="mt-2.5 pb-4!"
                        hasNavigation
                        buttonPrevClassName="-left-4 top-[calc(50%-8px)]"
                        buttonNextClassName="-right-4 top-[calc(50%-8px)]"
                        breakpoints={{
                            412: {
                                slidesPerView: 1.7,
                                spaceBetween: 20,
                            },
                            390: {
                                slidesPerView: 1.6,
                                spaceBetween: 16,
                            },
                            360: {
                                slidesPerView: 1.5,
                                spaceBetween: 16,
                            },
                            340: {
                                slidesPerView: 1.35,
                                spaceBetween: 15,
                            },
                        }}>
                        {usefulInformation?.map(
                            (item, index) =>
                                item?.__typename === 'Post' && (
                                    <SwiperSlide key={item?.id ? item?.id : index} className="cursor-pointer">
                                        <UsefulInformationItem usefulInformation={item as Post} />
                                    </SwiperSlide>
                                ),
                        )}
                    </CustomSwiper>
                )}
            </div>
        </div>
    );
}

export default UsefulInformationMobile;
